import { BottomNavDashboard } from '@/components/dashboard/_mobile/BottomNavDashboard'
import { PlusButtonMobile } from '@/components/dashboard/_mobile/PlusButtonMobile'
import { LeftNavDashboard } from '@/components/dashboard/LeftNavDashboard'
import { UniversalSearch } from '@/components/search/UniversalSearch'

import { TopNavMobile } from '@/components/dashboard/TopNavDashboard'
import { SidebarProvider } from '@/components/ui/sidebar'
import { useIsMobile } from '@/hooks/use-mobile'
import {
  createFileRoute,
  Outlet,
  useLocation,
  useRouteContext,
} from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_dashboard')({
  component: RouteComponent,
})

export const LEFT_NAV_WIDTH = '12rem'
export const LEFT_NAV_WIDTH_ICON = '4rem'

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile()
  const { pathname } = useLocation()
  const isScan = pathname.includes('/scan')
  const { hasAnyEditorAccess } = useRouteContext({
    from: '/_authenticated',
  })
  const canCreateDocument = hasAnyEditorAccess

  return (
    <>
      <SidebarProvider
        name="left-nav"
        className="h-full overflow-y-hidden"
        sidebarWidth={LEFT_NAV_WIDTH}
        sidebarWidthIcon={LEFT_NAV_WIDTH_ICON}
        defaultOpen={false}
      >
        {!isMobile && <LeftNavDashboard />}
        <SidebarProvider
          name="project-list"
          className="h-full overflow-y-hidden"
          open={true}
        >
          {isMobile && !isScan && <TopNavMobile />}
          {children}
        </SidebarProvider>
      </SidebarProvider>
      {isMobile && canCreateDocument && <PlusButtonMobile />}
      {isMobile && <BottomNavDashboard />}
      <UniversalSearch />
    </>
  )
}

function RouteComponent() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}
